import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../firebase';

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    const path = location.pathname + location.search;
    logPageView(path);
  }, [location]);

  // Track initial page load
  useEffect(() => {
    const path = window.location.pathname + window.location.search;
    logPageView(path);
  }, []);

  return null; // This component doesn't render anything
}

export default PageViewTracker;

